var DialogApprovalsEquipmentsApproveModule = /** @class */ (function () {
    function DialogApprovalsEquipmentsApproveModule() {
    }
    return DialogApprovalsEquipmentsApproveModule;
}());
export { DialogApprovalsEquipmentsApproveModule };
